import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Material UI components
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";

// Custom Components
import Filter from "@Components/Filter";
import Table from "components/Table";
import Modal from "@Components/Modal";
import { useNotifyContext } from "@Components/Notify";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useHistory } from "react-router-dom";



import {
  WORKER_URL,
  LIST_WORKER_GROUP_URL,
  WORKER_QR_URL,
  WORKER_QR_PRINT_URL,
  ZONE_FETCH_URL,
  REGION_FETCH_URL,
  ESTATE_FETCH_URL,
} from "configs/constants";
import eightAxios from "configs/axiosConfig";
import axios from "axios";
import { COMPANY_FETCH_URL } from "configs/constants";


let model = [
  { id: "employee_id", label: "Worker ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "mobile_number", label: "Mobile Number", type: "string" },
  { id: "id_number", label: "ID Number", type: "string" },
  { id: "worker_group", label: "Worker Group", type: "string", order: "name" },
  { id: "estate", label: "Estate", type: "string", order: "name" },
  { id: "status", label: "Status", type: "string" },
];
const actions = ["edit", "delete"];

const isUserDelete = true;


const FileDownload = require("js-file-download");
const today = new Date();

const SendSms = (props) => {
  const { messageBody, setMessageBody } = props;
  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <div>{messageBody}</div>
      </Grid>
      <Grid item>
        <TextField
          onChange={(event) => {
            setMessageBody(event.target.value);
          }}
          variant="outlined"
          row={5}
          multiline
          fullWidth
        />
      </Grid>
    </Grid>
  );
};
SendSms.propTypes = {
  messageBody: PropTypes.string,
  setMessageBody: PropTypes.func,
  
};
const getCompanyValues = (e, setDisableZone) => {
  if (!e || e.length === 0) {
    setDisableZone(true);
  }
  else {
    setDisableZone(false);
  }

};
const getZoneValues = (e, setDisableRegion) => {
//  if (!e || e.length === 0) {
  if (!e || e.length === 0 || e.label == "N/A") {
    setDisableRegion(true);
  }
  else {
    setDisableRegion(false);
  }

};
const getRegionValues = (e, setDisableEstate) => {
  if (!e || e.length === 0) {
    setDisableEstate(true);
  }
  else {
    setDisableEstate(false);
  }

};
export default function UserList() {
  // Use a state to store the table's selected values and also provide a callback function
  const [selected, setSelected] = useState([]);
  const [messageBody, setMessageBody] = useState("");
  const [filterValues, setFilterValues] = useState({});
  const history = useHistory();
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [disableZone, setDisableZone] = useState(true);


 

  const [modalFields, setModalFields] = useState({
    title: "Send SMS",
    isOpen: false,
    body: null,
    confirmButtonLabel: "Send",
    onConfirm: null,
    resetModalBodyState: setMessageBody,
  });
  const setNotify = useNotifyContext();

  const filterFields = [
    {
      type: "reactselect",
      label: "Status",
      name: "status",
      outerOptions: [
        { id: "Active", name: "Active" },
        { id: "Inactive", name: "Inactive" },
      ],
    },
    {
      type: "input",
      label: "Worker ID",
      name: "employee_id",
    },
    {
      type: "input",
      label: "Name",
      name: "name",
    },
    {
      type: "input",
      label: "Mobile Number",
      name: "mobile_number",
    },
    {
      type: "input",
      label: "ID Number",
      name: "id_number",
    },
    {
      type: "reactselect",
      label: "Worker Group",
      name: "worker_group",
      proxyUrl: LIST_WORKER_GROUP_URL,
      paginated: false,
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
  
  
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      disabled:disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,

      disabled: disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      disabled: disableEstate,
      paginated: true,
      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "api",
      label: "API",
      outerOptions: [
        { id: "1", name: "Yes" },
        { id: "0", name: "No" },
      ],
      paginated: true,
    },
  ];


  useEffect(() => {
    setModalFields({
      ...modalFields,
      body: (
        <SendSms messageBody={messageBody} setMessageBody={setMessageBody} />
      ),
      onConfirm: () => {
        console.log(messageBody);
        setModalFields({ ...modalFields, isOpen: false });
      },
    });
  }, [messageBody]);

  const filterInitialValues = {
    employee_id: "",
    name: "",
    mobile_number: "",
    id_number: "",
    worker_group: "",
    zone: "",
    region: "",
    estate: "",
    status: "",
  };
  const pageNumberDropdown = true;
  const noData = true;

  const API_VERSION = "v1";
  const API_URL = process.env.REACT_APP_API_URL;
  let baseURL = `${API_URL}${API_VERSION}/`;

  // Action buttons props
  const actionBarButtons = [
    {
      color: "primary",
      buttonLabel: "Download QR Code",
      onClick: () => {
        if (selected.length === 0) {
          setNotify({
            isOpen: true,
            message: "Please select one or more workers to download QR",
            type: "error",
          });
        } else {
          const body = { ids: selected, ...filterValues };
          const url = baseURL + WORKER_QR_URL;
          const headers = {
            Authorization: `JWT ${localStorage.getItem("token")}`,
          };
          axios({
            url: url,
            method: "get",
            headers: headers,
            responseType: "blob",
            params: body,
          }).then(function (response) {
            let date =
              today.getFullYear() +
              "-" +
              (today.getMonth() + 1) +
              "-" +
              today.getDate();
            FileDownload(response.data, "Worker_QR_Code" + date + ".pdf");
          });
        }
      },
    },
    {
      color: "primary",
      buttonLabel: "Print QR Code",
      onClick: () => {
        if (selected.length === 0) {
          setNotify({
            isOpen: true,
            message: "Please select one or more workers to print QR",
            type: "error",
          });
        } else {
          const config = { params: { ids: selected, ...filterValues } };

          eightAxios.get(WORKER_QR_PRINT_URL, config).then((response) => {
            const url = response.data.file_path;
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            link.remove();
          });
        }
      },
    },
  ];
  const onFilterRequest = (values) => {
    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };
  const clearFilter = () => {
    filterInitialValues.status = null
    location.reload();
  }


  return (
    <div>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
        onClear={clearFilter}

      />

      {filtersApplied ? (
        <Table
          proxyURL={WORKER_URL}
          model={model}
          actions={actions}
          excelExport={{ fileName: "WorkerReport" }}
          filterValues={filterValues}
          pageNumberDropdown={pageNumberDropdown}
          actionBarButtons={actionBarButtons}
          noFilter
          isUserDelete={isUserDelete}
          check
          selected={selected}
          setSelected={setSelected}
        />
      ) : (
        <Table
          proxyURL={null}
          model={model}
          actions={actions}
          excelExport={{ fileName: "WorkerReport" }}
          filterValues={filterValues}
          pageNumberDropdown={pageNumberDropdown}
          actionBarButtons={actionBarButtons}
          noFilter
          isUserDelete={isUserDelete}
          check
          selected={selected}
          setSelected={setSelected}
        />
      )}

      <Modal modalFields={modalFields} setModalFields={setModalFields} />
    </div>
  );
}
